import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FiArrowLeft, FiSave, FiFileText, FiFile } from 'react-icons/fi';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { materialsAPI } from '../../../services/api';
import './MaterialsPage.css';

const CreateMaterialPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [material, setMaterial] = useState({
        title: '',
        description: '',
        type: 'text',
        content: '',
        file: null
    });

    useEffect(() => {
        if (id) {
            loadMaterial();
        }
    }, [id]);

    const loadMaterial = async () => {
        try {
            const response = await materialsAPI.getMaterial(id);
            setMaterial(response.data);
        } catch (error) {
            console.error('Ошибка загрузки материала:', error);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!material.title) {
            alert('Заполните название материала');
            return;
        }

        if (material.type === 'text' && !material.content) {
            alert('Добавьте содержимое материала');
            return;
        }

        if (material.type === 'file' && !material.file && !id) {
            alert('Выберите файл для загрузки');
            return;
        }

        try {
            setLoading(true);
            
            const formData = new FormData();
            formData.append('title', material.title);
            formData.append('description', material.description || '');
            formData.append('type', material.type);
            
            if (material.type === 'text') {
                formData.append('content', material.content);
            } else if (material.file) {
                formData.append('file', material.file);
            }

            if (id) {
                await materialsAPI.updateMaterial(id, formData);
            } else {
                await materialsAPI.createMaterial(formData);
            }

            navigate('/admin/materials');
        } catch (error) {
            console.error('Ошибка сохранения материала:', error);
            alert('Ошибка при сохранении материала');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="create-material-page">
            <div className="create-material-header">
                <button 
                    onClick={() => navigate('/admin/materials')}
                    className="btn-back-mat"
                >
                    <FiArrowLeft />
                    Назад
                </button>
                <h1>{id ? 'Редактировать материал' : 'Создать материал'}</h1>
            </div>

            <form onSubmit={handleSubmit} className="material-form">
                {/* Выбор типа материала */}
                {!id && (
                    <div className="form-group">
                        <label>Тип материала</label>
                        <div className="type-selector">
                            <button
                                type="button"
                                className={`type-btn ${material.type === 'text' ? 'active' : ''}`}
                                onClick={() => setMaterial({ ...material, type: 'text' })}
                            >
                                <FiFileText size={24} />
                                <span>Текстовый материал</span>
                            </button>
                            <button
                                type="button"
                                className={`type-btn ${material.type === 'file' ? 'active' : ''}`}
                                onClick={() => setMaterial({ ...material, type: 'file' })}
                            >
                                <FiFile size={24} />
                                <span>Файл</span>
                            </button>
                        </div>
                    </div>
                )}

                {/* Название */}
                <div className="form-group">
                    <label>Название *</label>
                    <input
                        type="text"
                        value={material.title}
                        onChange={(e) => setMaterial({ ...material, title: e.target.value })}
                        placeholder="Введите название материала"
                        required
                    />
                </div>

                {/* Описание */}
                <div className="form-group">
                    <label>Описание</label>
                    <textarea
                        value={material.description}
                        onChange={(e) => setMaterial({ ...material, description: e.target.value })}
                        placeholder="Краткое описание материала"
                        rows="3"
                    />
                </div>

                {/* Контент для текстового материала */}
                {material.type === 'text' && (
                    <div className="form-group">
                        <label>Содержимое *</label>
                        <ReactQuill
                            value={material.content}
                            onChange={(value) => setMaterial({ ...material, content: value })}
                            modules={{
                                toolbar: [
                                    [{ 'header': [1, 2, 3, false] }],
                                    ['bold', 'italic', 'underline', 'strike'],
                                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                                    [{ 'color': [] }, { 'background': [] }],
                                    ['link', 'image'],
                                    ['clean']
                                ]
                            }}
                            placeholder="Введите содержимое материала..."
                        />
                    </div>
                )}

                {/* Файл */}
                {material.type === 'file' && (
                    <div className="form-group">
                        <label>Файл {!id && '*'}</label>
                        <input
                            type="file"
                            onChange={(e) => setMaterial({ ...material, file: e.target.files[0] })}
                            accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar"
                        />
                        {material.file && (
                            <p className="file-info">Выбран файл: {material.file.name}</p>
                        )}
                        {id && material.file_url && !material.file && (
                            <p className="file-info">Текущий файл: {material.file_url.split('/').pop()}</p>
                        )}
                    </div>
                )}

                {/* Кнопки */}
                <div className="form-actions">
                    <button
                        type="button"
                        onClick={() => navigate('/admin/materials')}
                        className="btn-cancel"
                        disabled={loading}
                    >
                        Отмена
                    </button>
                    <button
                        type="submit"
                        className="btn-save-mat"
                        disabled={loading}
                    >
                        <FiSave />
                        {loading ? 'Сохранение...' : 'Сохранить'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default CreateMaterialPage;
